export default __webpack_public_path__ + "static/media/V2-CARROUSEL_3.867fa030.jpg";